import React from 'react'

const ArchiveIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.99 2H2.01C1.56 2 1.2 2.36 1.2 2.81V4.67C1.2 5.12 1.56 5.48 2.01 5.48H13.99C14.44 5.48 14.8 5.12 14.8 4.67V2.81C14.8 2.36 14.44 2 13.99 2Z" stroke="#C57060" strokeWidth="0.74" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.81 5.48V12.65C2.81 13 2.96 13.33 3.19 13.56C3.42 13.8 3.75 13.94 4.1 13.94H11.9C12.25 13.94 12.58 13.8 12.81 13.56C13.04 13.33 13.19 13 13.19 12.65V5.48" stroke="#C57060" strokeWidth="0.74" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.67 8.01H9.33" stroke="#C57060" strokeWidth="0.74" strokeLinecap="round" strokeLinejoin="round" />
    </svg>


  )
}

export default ArchiveIcon
